import React from 'react';
import { useField, useFormikContext, FormikValues } from 'formik';
import CheckIcon from 'mdi-react/CheckIcon';

interface Props {
  id: string;
  name: string;
  className?: string;
  value: boolean;
  text: string;
  disabled?: boolean;
  onChangeAction?: () => void;
}

const FormCheckbox = (props: Props) => {
  const { id, name, text, value, className, disabled, onChangeAction } = props;
  const form = useFormikContext<FormikValues>();
  const [field] = useField<string>(name);

  const CheckedLabelClass = field.value ? 'checked' : '';

  const onFieldChange = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (disabled) {
      return;
    }
    e.preventDefault();
    form.setFieldTouched(name, true);

    form.setFieldValue(name, !value);

    if (onChangeAction) {
      onChangeAction();
    }
  };

  return (
    <div role="presentation" onClick={onFieldChange}>
      <label
        className={`${className || ''} checkbox-btn${disabled ? ' disabled' : ''}`}
        htmlFor={id}
      >
        <input
          id={id}
          className="checkbox-btn__checkbox"
          type="checkbox"
          name={name}
          value={value.toString()}
          onChange={() => {}}
          checked={value}
          disabled={disabled}
        />
        <span className="checkbox-btn__checkbox-custom">
          <CheckIcon />
        </span>
        <span className={`checkbox-btn__label ${CheckedLabelClass}`}>{text}</span>
      </label>
    </div>
  );
};

export default FormCheckbox;
